import styled from 'styled-components'

export const TransactionsContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: ${({ theme }) => theme.colors.background.primary};

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 12px;
  }
`

export const TransactionsStatsSection = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 8px;
  padding-top: 20px;
`

export const TransactionsMetricCard = styled.div<{
  highlight?: boolean
  accent?: boolean
}>`
  background: ${({ highlight, accent, theme }) =>
    accent
      ? `linear-gradient(135deg, ${theme.colors.primary}10 0%, ${theme.colors.primary}05 100%)`
      : highlight
        ? theme.colors.background.secondary
        : theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  border-radius: 8px;
  padding: 16px;
  min-width: 150px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadows.sm};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    flex: 1 1 45%;
    min-width: 130px;
  }
`

export const TransactionsMetricLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`

export const TransactionsMetricValue = styled.div<{ color?: string }>`
  font-size: 20px;
  font-weight: 700;
  color: ${({ color, theme }) => color || theme.colors.text.primary};
  margin-bottom: 4px;
`

export const TransactionsEmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 48px 24px;
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 8px;
  border: 2px dashed ${({ theme }) => theme.colors.border.light};
`

export const TransactionsEmptyStateIcon = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.background.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`

export const TransactionsEmptyStateText = styled.div`
  text-align: center;
  max-width: 400px;
`
